import { BROADCAST } from '../stores/backendEventsStore';
import { useNotificationsStore } from '../stores/notificationsStore';
import { type BackendNotification, type NotificationAction, NotificationActionType } from '../types/notifications';

export default defineNuxtPlugin(() => {
    const { addHandler } = useNotificationsStore();
    addHandler(BROADCAST, (notification: BackendNotification): (NotificationAction | undefined) => {
        if (!notification.data.subject && !notification.data.message) { return undefined; } else {
            return {
                actionType: NotificationActionType.SHOW_TOAST,
                payload: {
                    detail: notification.data.message!,
                    summary: notification.data.subject
                }
            };
        }
    });
});
